import { render, staticRenderFns } from "./forecasting.vue?vue&type=template&id=0bd80a8d&"
import script from "./forecasting.vue?vue&type=script&lang=js&"
export * from "./forecasting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports